import {Link, useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Button, Card, CardBody, IconButton, Input, Textarea, Typography} from "@material-tailwind/react";
import Footer from "./footer";
import {CheckCircle, User} from "lucide-react";
import SummaryPanel from "./SummaryPanel";
import MobileNextButton from "./MobileNextButton";

function Contact() {
    //const nextUrl = "/review";
    const navigate = useNavigate();
    const rightProps = {nextUrl: "/review", ready: false};
    const [searchParams, setSearchParams] = useSearchParams();

    const [selectedFirstName, setSelectedFirstName] = useState("");
    const [selectedLastName, setSelectedLastName] = useState("");
    const [selectedEmail, setSelectedEmail] = useState("");
    const [selectedPhone, setSelectedPhone] = useState("");
    const [selectedMemo, setSelectedMemo] = useState("");
    const [serviceList, setServiceList] = useState(null);
    const [count, setCount] = useState(0);
    const [customer, setCustomer] = useState([]);
    const [branch, setBranch] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getCustomer = async () => {
        setServiceList(JSON.parse(localStorage.getItem("services")));
        try {
            await axios
                .get(process.env.REACT_APP_API_URL + "/api/v1/getCustomer", {
                    withCredentials: true,
                })
                .then((response) => {
                    setCustomer(response.data);

                    setSelectedFirstName(response.data.firstName);
                    localStorage.setItem("firstname", response.data.firstName);

                    setSelectedLastName(response.data.lastName);
                    localStorage.setItem("lastname", response.data.lastName);

                    setSelectedEmail(response.data.email);
                    localStorage.setItem("email", response.data.email);

                    setSelectedPhone(response.data.phone);
                    localStorage.setItem("phone", response.data.phone);
                })
                .catch((error) => {
                    navigate("/");
                    console.log(error);
                });
        } catch (e) {
            console.log(e);
        }
    };

    const getAddress = async () => {
        //localStorage.clear();
        try {
            await axios
                .get(process.env.REACT_APP_API_URL + "/api/v1/getAddress", {
                    withCredentials: true,
                })
                .then((response) => {
                    setBranch(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    navigate("/");
                });
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getCustomer();
        getAddress();
    }, []);

    const firstNameHandler = (event) => {
        setSelectedFirstName(event.target.value);
        localStorage.setItem("firstname", event.target.value);
    };

    const lastNameHandler = (event) => {
        setSelectedLastName(event.target.value);
        localStorage.setItem("lastname", event.target.value);
    };

    const emailHandler = (event) => {
        setSelectedEmail(event.target.value);
        localStorage.setItem("email", event.target.value);
    };

    const phoneHandler = (event) => {
        setSelectedPhone(event.target.value.replace(/\D/g, ''));
        localStorage.setItem("phone", event.target.value.replace(/\D/g, ''));
    };

    const memoHandler = (event) => {
        setSelectedMemo(event.target.value);
        localStorage.setItem("bookMemo", event.target.value);
        setCount(event.target.value.length);
    };

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-50 scroll-container" style={{WebkitOverflowScrolling: 'touch', overscrollBehavior: 'none'}}>
                <div className="container mx-auto max-w-7xl px-4 py-4 sm:py-6">
                    {/* Enhanced Header with back button */}
                    <div className="mb-6 sm:mb-8">
                        <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                            <IconButton
                                variant="outlined"
                                color="blue-gray"
                                size="lg"
                                onClick={() => navigate("/carinfo")}
                                className="border-gray-300 hover:bg-gray-50 transition-all duration-300"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="currentColor"
                                    className="w-5 h-5 sm:w-6 sm:h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                                    />
                                </svg>
                            </IconButton>
                            <div>
                                <Typography variant="h4" color="blue-gray"
                                            className="font-bold text-xl sm:text-2xl lg:text-3xl">
                                    Contact Information
                                </Typography>
                                <Typography variant="paragraph" color="gray" className="mt-1 text-sm sm:text-base">
                                    Please provide your contact details
                                </Typography>
                            </div>
                        </div>

                        {/* Progress indicator */}
                        <div className="flex items-center justify-center mb-6 sm:mb-8 overflow-x-auto px-2 sm:px-4 overflow-y-hidden">
                            <div className="flex items-center justify-between w-full max-w-4xl">
                                {/* Step 1 - Select Services */}
                                <div className="flex items-center justify-center">
                                    <div className="flex items-center cursor-pointer" onClick={() => navigate("/services")}>
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0 cursor-pointer hover:bg-green-600 transition-colors duration-300"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        {/* Text label - hidden on mobile */}
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            Services
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 1 */}
                                <div className="flex-1 h-0.5 bg-blue-500 mx-2 sm:mx-4"></div>

                                {/* Step 2 - Choose Schedule */}
                                <div className="flex items-center justify-center">
                                    <div className="flex items-center cursor-pointer" onClick={() => navigate("/schedule")}>
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0 cursor-pointer hover:bg-green-600 transition-colors duration-300"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        {/* Text label - hidden on mobile */}
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            Schedule
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 2 */}
                                <div className="flex-1 h-0.5 bg-blue-500 mx-2 sm:mx-4"></div>

                                {/* Step 3 - Car Information */}
                                <div className="flex items-center justify-center">
                                    <div className="flex items-center cursor-pointer" onClick={() => navigate("/carinfo")}>
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0 cursor-pointer hover:bg-green-600 transition-colors duration-300"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        {/* Text label - hidden on mobile */}
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            Car
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 3 */}
                                <div className="flex-1 h-0.5 bg-blue-500 mx-2 sm:mx-4"></div>

                                {/* Step 4 - Contact Information (CURRENT) */}
                                <div className="flex items-center justify-center relative">
                                    <div className="relative">
                                        {/* Pulsing ring animation - hidden on mobile */}
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-500 rounded-full animate-ping opacity-20 hidden sm:block"></div>
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-500 rounded-full animate-pulse opacity-30 hidden sm:block"></div>

                                        {/* Main step indicator */}
                                        <div className="relative w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-full flex items-center justify-center text-sm sm:text-base md:text-lg font-bold shadow-lg border-2 sm:border-4 border-white flex-shrink-0 z-10">
                                            4
                                        </div>
                                    </div>

                                    {/* Current step indicator - hidden on mobile */}
                                    <div className="ml-2 sm:ml-3 hidden sm:block">
                                        <Typography variant="small"
                                                    className="font-bold text-blue-600 text-sm sm:text-base whitespace-nowrap">
                                            Contact
                                        </Typography>
                                        <div className="text-xs text-blue-500 font-medium">
                                            Current Step
                                        </div>
                                    </div>
                                </div>

                                {/* Connector line 4 */}
                                <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>

                                {/* Step 5 - Complete */}
                                <div className="flex items-center justify-center">
                                    <div
                                        className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0">
                                        5
                                    </div>
                                    {/* Text label - hidden on mobile */}
                                    <Typography variant="small"
                                                className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block">
                                        Complete
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 justify-center">
                        {/* Enhanced Contact Information Section */}
                        <div className="flex-1 max-w-5xl">
                            <Card className="border-0 shadow-xl bg-white/80 backdrop-blur-sm">
                                <CardBody className="p-4 sm:p-6 lg:p-8">
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
                                        {/* Contact Information Form */}
                                        <div className="lg:col-span-2">
                                            <div className="mb-6 sm:mb-8">
                                                <div className="flex items-center gap-2 mb-2">
                                                    <User className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600"/>
                                                    <Typography variant="h5" color="blue-gray"
                                                                className="font-bold text-lg sm:text-xl lg:text-2xl">
                                                        Contact Details
                                                    </Typography>
                                                </div>
                                                {/*<Typography variant="paragraph" color="gray"*/}
                                                {/*            className="mb-4 sm:mb-6 text-sm sm:text-base">*/}
                                                {/*    Please provide your contact information for booking confirmation.*/}
                                                {/*</Typography>*/}
                                            </div>

                                            <div className="space-y-6">
                                                <div className="space-y-4">
                                                    <div>
                                                        <Typography variant="small"
                                                                    className="mb-2 font-medium text-blue-gray-700">
                                                            First Name
                                                        </Typography>
                                                        <input
                                                            type="text"
                                                            value={selectedFirstName}
                                                            onChange={firstNameHandler}
                                                            maxLength={20}
                                                            placeholder="Enter your first name"
                                                            className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"

                                                        />
                                                    </div>

                                                    <div>
                                                        <Typography variant="small"
                                                                    className="mb-2 font-medium text-blue-gray-700">
                                                            Last Name
                                                        </Typography>
                                                        <input
                                                            type="text"
                                                            value={selectedLastName}
                                                            onChange={lastNameHandler}
                                                            maxLength={20}
                                                            placeholder="Enter your last name"
                                                            className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"

                                                        />
                                                    </div>

                                                    <div>
                                                        <Typography variant="small"
                                                                    className="mb-2 font-medium text-blue-gray-700">
                                                            Email Address
                                                        </Typography>
                                                        <input
                                                            type="email"
                                                            value={selectedEmail}
                                                            onChange={emailHandler}
                                                            placeholder="Enter your email address"
                                                            className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"

                                                        />
                                                    </div>

                                                    <div>
                                                        <Typography variant="small"
                                                                    className="mb-2 font-medium text-blue-gray-700">
                                                            Phone Number
                                                        </Typography>
                                                        <input
                                                            type="text"
                                                            value={selectedPhone}
                                                            onChange={phoneHandler}
                                                            maxLength={20}
                                                            placeholder="Enter your phone number"
                                                            className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"

                                                        />
                                                    </div>
                                                </div>

                                                <div className="pt-6 border-t border-gray-200">
                                                    <Typography variant="h6"
                                                                className="mb-4 font-semibold text-blue-gray-800">
                                                        Additional Information
                                                    </Typography>
                                                    {/*<Typography variant="small" color="gray" className="mb-4">*/}
                                                    {/*    Optional notes or special requests*/}
                                                    {/*</Typography>*/}

                                                    <div>
                                                        {/*<Typography variant="small"*/}
                                                        {/*            className="mb-2 font-medium text-blue-gray-700">*/}
                                                        {/*    Notes / Special Requests*/}
                                                        {/*</Typography>*/}
                                                        <Textarea
                                                            value={selectedMemo}
                                                            onChange={memoHandler}
                                                            maxLength="250"
                                                            rows={4}
                                                            placeholder="Enter any additional information or special requests (optional)"
                                                            className="!border-2 !border-gray-200 focus:!border-blue-500 !bg-white hover:!border-gray-300 transition-all duration-300 !shadow-sm hover:!shadow-md !rounded-xl"
                                                            labelProps={{
                                                                className: "before:content-none after:content-none",
                                                            }}
                                                        />
                                                        <div className="text-right text-xs mt-2 text-gray-500">{count}/250</div>
                                                    </div>
                                                </div>

                                                {/* Mobile Next Button */}
                                                <MobileNextButton
                                                    link="/review"
                                                    enabled={selectedFirstName && selectedLastName && selectedEmail && selectedPhone}
                                                    buttonText="Next Step →"
                                                    disabledText="Please complete required fields"
                                                />
                                            </div>
                                        </div>

                                        {/* Enhanced Summary Panel */}
                                        <div className="lg:col-span-1 order-first lg:order-last hidden lg:block">
                                            <SummaryPanel
                                                link={"/review"}
                                                branch={branch}
                                                selectedServiceList={serviceList}
                                                dateList={localStorage.getItem("bookingtime")}
                                                selectedCar={localStorage.getItem("eid")}
                                                carList={[{
                                                    eid: localStorage.getItem("eid"),
                                                    make: localStorage.getItem("make"),
                                                    model: localStorage.getItem("model"),
                                                    year: localStorage.getItem("year")
                                                }]}
                                                enabled={selectedFirstName && selectedLastName && selectedEmail && selectedPhone}
                                            />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </>
    );
}

export default Contact;
